var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.page.state != 'rendered')?_c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),(_vm.shouldRender)?_c('PDFCanvasV3',{attrs:{"page":_vm.page}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }